enum ActionButton {
  GravityForm = "GravityForm",
  UnAssigned = "UnAssigned",
  IcoModal = "IcoModal",
  OpenCreditApp = "OpenCreditApp",
}

export default ActionButton;
